import { Drawer, Table } from 'antd'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import PropTypes from 'prop-types'

const RecordModal = ({ visible, onClose, auditList, onChangeTable, tablePagination }) => {
  const { t } = useTranslation()

  const columns = [
    {
      title: t('FIELD_DATE'),
      dataIndex: 'created_at',
      key: 'fecha',
      render: (date) => moment(date).calendar(),
    },
    {
      title: t('LABEL_USER'),
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: t('FIELD_MESSAGE'),
      dataIndex: 'message',
      key: 'nombre',
    },
  ]

  return (
    <Drawer title={t('LABEL_RECORD')} visible={visible} onClose={onClose} size="large">
      <Table
        size="small"
        dataSource={auditList.values.map((el, index) => {
          return { ...el, key: `${el.key}_${index}` }
        })}
        columns={columns}
        onChange={onChangeTable}
        pagination={{
          pageSize: tablePagination.page_size,
          current: tablePagination.page,
          total: auditList.count,
          pageSizeOptions: ['10', '20', '30'],
          showSizeChanger: true,
          size: 'small',
        }}
      />
    </Drawer>
  )
}

RecordModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  auditList: PropTypes.shape({
    values: PropTypes.array,
  }),
  onChangeTable: PropTypes.func,
}

export default RecordModal
